export default class ApiProgress {
    activeCalls: number = 0;
    lastSaved: Date = new Date();
    isComplete: boolean = true;
}